import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DiskCapacityBar = styled.div<React.CSSProperties>`
  position: fixed;
  width: ${1690 * Screen.widthRatio}px;
  margin-top: ${90 * Screen.widthRatio}px;
  height: ${225 * Screen.widthRatio}px;
`;

export default DiskCapacityBar;
